if (!customElements.get('carousel-component')) {
  customElements.define(
    'carousel-component',
    class CarouselComponents extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        const prevBtn = this.querySelector('.product-carousel-prev');
        const nextBtn = this.querySelector('.product-carousel-next');

        let position = 0;

        const moveCarousel = (direction) => {
          if (direction == 'forward') {
            if (position == 1) {
              nextBtn.classList.add('hide-arrow');
            }
            if (position == 2) {
              return false;
            }
            prevBtn.classList.remove('hide-arrow');
            position++;
          } else if (direction == 'backward') {
            if (position == 1) {
              prevBtn.classList.add('hide-arrow');
            }
            if (position == 0) {
              return false;
            }
            nextBtn.classList.remove('hide-arrow');
            position--;
          }

          const firstItem = this.querySelector('.carousel-item');
          const width = firstItem.offsetWidth;
          const margin = parseFloat(window.getComputedStyle(firstItem).marginRight);
          const totalWidth = width + margin;

          const offset = totalWidth * position;
          this.querySelectorAll('.carousel-item').forEach((carouselItemElement) => {
            carouselItemElement.style.transform = `translateX(-${offset}px)`;
          });
        };

        prevBtn.addEventListener('click', () => {
          moveCarousel('backward');
        });
        nextBtn.addEventListener('click', () => {
          moveCarousel('forward');
        });
      }

      disconnectedCallback() {
        prevBtn?.removeEventListener('click', () => {
          moveCarousel('backward');
        });
        nextBtn?.removeEventListener('click', () => {
          moveCarousel('forward');
        });
      }
    },
  );
}
